import { useAppContext } from "app/AppContext";
import NascimentoForm from "entity/Nascimento/components/NascimentoForm"
import NascimentoConsulta from "entity/Nascimento/components/NascimentoConsulta"
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import IconCow from './iconpro.png'

export default function RoutesMenusNascimento() {
    const navigate = useNavigate();
    const { addMenu, addRoute, removeMenusRoutes } = useAppContext();

    useEffect(() => {
        addMenu({
            uid: "Nascimento",
            text: "Lançar Nascimento",
            sequence: "222221",
            iconFile: IconCow,
            action: () => {
                navigate("/nascimento");
            },
        });

        addRoute({ uid: "Nascimento", title: "Lançar Nascimento", route: "nascimento", element: <NascimentoForm /> });

        addMenu({
            uid: "consultaNascimentos",
            text: "Nascimentos",
            sequence: "222222",
            iconName: "Search",
            action: () => {
                navigate("/consultaNascimentos");
            },
        });

        addRoute({ uid: "consultaNascimentos", title: "Nascimentos", route: "consultaNascimentos", element: <NascimentoConsulta /> });

        return () => {
            removeMenusRoutes(["Nascimento", "consultaNascimentos"]);
        };
    }, [addMenu, addRoute, navigate, removeMenusRoutes]);

    return null;
}
